import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import { Column } from '~/modules/coreUI/components/legacies/Columns';
import { LargeLabel } from '~/modules/coreUI/components/legacies/Labels';

const BannerWrapper = styled.div`
  height:150px;
  position: relative;
`;
const BannerImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${props => props.theme.borders.radius.normal}px;
  box-shadow: 0px 1px 5px 0 rgba(0, 0, 0, 0.1);
`;
const Label = styled(LargeLabel)`
  text-transform: capitalize;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  padding: 12px 16px;  
  background: ${props => props.theme.colors.invertedLabels.subtle};
  color: ${props => props.theme.colors.labels.normal};
  ${props => cssMediaMax.tablet`
    font-size: ${props.theme.fonts.sizes.medium}px;
  `}
  border: 1px solid ${props => props.theme.borders.color.extraLight};
  border-bottom: none;
  border-top-left-radius: ${props => props.theme.borders.radius.normal}px;
  border-top-right-radius: ${props => props.theme.borders.radius.normal}px;
  white-space: nowrap;  
`;
const LabelWrapper = styled(Column)`
  height: 100%;
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: 0 15px;
`;

const BannerWithLabel = ({ logo, name }) => (
  <BannerWrapper>
    <BannerImg src={logo} alt={logo} />
    {name && (
      <LabelWrapper endJustified leftAligned>
        <Label>{name}</Label>
      </LabelWrapper>
    )}
  </BannerWrapper>
);
BannerWithLabel.propTypes = {
  logo: PropTypes.string.isRequired,
  name: PropTypes.string,
};
BannerWithLabel.defaultProps = {
  name: null,
};

export default BannerWithLabel;
